import tmhRequest from "@/config/tmhRequest";

export default {
  searchBrandBusinessReportCount: function(data) {
    return tmhRequest({
      url: "/report/ispa/businessreport/searchbrandbusinessreportcount",
      method: "post",
      data: data
    });
  },
  searchBrandBusinessReportByPage: function(data) {
    return tmhRequest({
      url: "/report/ispa/businessreport/searchbrandbusinessreportbypage",
      method: "post",
      data: data
    });
  },

  searchBusinessReportCount: function(data) {
    return tmhRequest({
      url: "/report/ispa/businessreport/searchbusinessreportcount",
      method: "post",
      data: data
    });
  },
  searchBusinessReportByPage: function(data) {
    return tmhRequest({
      url: "/report/ispa/businessreport/searchbusinessreportbypage",
      method: "post",
      data: data
    });
  },
  exportBusinessReport: function(data) {
    return tmhRequest({
      url: "/report/ispa/businessreport/exportbusinessreport",
      method: "post",
      responseType: "blob",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/report/businessreport.js